type IconProps = React.HTMLAttributes<SVGElement> & {
	fill?: string
	width?: string
	height?: string
	stroke?: string
}

export const Icons = {
	spinnerCircle: (props: IconProps) => (
		<svg
			width="23"
			height="23"
			viewBox="0 0 23 23"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<circle
				cx="11.5"
				cy="11.7007"
				r="10"
				stroke="#07111A"
				strokeOpacity="0.2"
				strokeWidth="2"
			/>
		</svg>
	),
	iconGlobe: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_718_7582)">
				<path
					d="M1.3335 8.00016H14.6668M1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668M1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668M14.6668 8.00016C14.6668 4.31826 11.6821 1.3335 8.00016 1.3335M8.00016 1.3335C9.66768 3.15906 10.6153 5.52819 10.6668 8.00016C10.6153 10.4721 9.66768 12.8413 8.00016 14.6668M8.00016 1.3335C6.33264 3.15906 5.38499 5.52819 5.3335 8.00016C5.38499 10.4721 6.33264 12.8413 8.00016 14.6668"
					stroke={props.stroke || 'white'}
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_718_7582">
					<rect width="16" height="16" fill={props.fill || 'white'} />
				</clipPath>
			</defs>
		</svg>
	),
	minimize: (props: IconProps) => (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
			<path d="M12.6673 6.50423C11.6673 6.66732 9.8397 6.85579 9.48917 6.50423M9.48917 6.50423C9.13877 6.15268 9.33401 4.33398 9.48918 3.33398M9.48917 6.50423L13.999 2.00195" stroke="#1E293B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M3.33272 9.53288C4.33268 9.36979 6.1603 9.18132 6.51083 9.53288M6.51083 9.53288C6.86123 9.88443 6.66599 11.7031 6.51082 12.7031M6.51083 9.53288L2.00103 14.0352" stroke="#1E293B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	),
	expand: (props: IconProps) => (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
			<path d="M10.6647 2.1989C11.6647 2.03581 13.4923 1.84733 13.8429 2.1989M13.8429 2.1989C14.1933 2.55045 13.998 4.36914 13.8429 5.36914M13.8429 2.1989L9.33307 6.70117" stroke="#1E293B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5.37431 13.8363C4.37435 13.9993 2.54673 14.1878 2.1962 13.8363M2.1962 13.8363C1.8458 13.4847 2.04104 11.666 2.19621 10.666M2.1962 13.8363L6.706 9.33398" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	),
	flag: (props: IconProps) => (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
			<path d="M12.6004 5.06385C11.9147 4.67013 10.9063 4.26903 9.63307 3.76255L7.41093 2.8786C6.70509 2.59781 6.12655 2.36765 5.65899 2.25256C5.17709 2.13393 4.70059 2.1074 4.26873 2.36731C3.82443 2.63472 3.64886 3.07065 3.57221 3.54528C3.51718 3.88609 3.50407 4.30679 3.50096 4.79658C3.50032 4.80853 3.5 4.82057 3.5 4.83268V14.4993C3.5 14.8675 3.79848 15.166 4.16667 15.166C4.53485 15.166 4.83333 14.8675 4.83333 14.4993V11.8106C4.83333 11.6792 4.83333 11.6135 4.86783 11.5627C4.90232 11.5118 4.96337 11.4875 5.08549 11.4389L9.63307 9.62994C10.9063 9.12347 11.9147 8.72241 12.6004 8.32867C13.2777 7.93981 13.8333 7.45014 13.8333 6.69626C13.8333 5.94239 13.2777 5.45273 12.6004 5.06385Z" fill={props.fill || 'white'} />
		</svg>
	),
	close: (props: IconProps) => (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
			<path d="M12 4L4 12M4 4L12 12" stroke="#1E293B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	),
	iconClose: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18 6L6 18M6 6L18 18"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconCheck: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_52803_70348)">
				<path
					d="M14.6663 7.99967C14.6663 4.31777 11.6815 1.33301 7.99967 1.33301C4.31777 1.33301 1.33301 4.31777 1.33301 7.99967C1.33301 11.6815 4.31777 14.6663 7.99967 14.6663C11.6815 14.6663 14.6663 11.6815 14.6663 7.99967Z"
					stroke={props.stroke || 'currentColor'}
					strokeWidth="1.5"
				/>
				<path
					d="M5.33301 8L7.33301 10L10.6663 6"
					stroke={props.stroke || 'currentColor'}
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_52803_70348">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	),
	iconBadge: (props: IconProps) => (
		<svg
			width="33"
			height="33"
			viewBox="0 0 33 33"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M21.5 31.75L20.836 32.0986C20.968 32.3501 21.2307 32.5054 21.5146 32.4999C21.7986 32.4943 22.055 32.3289 22.1771 32.0725L21.5 31.75ZM24 26.5V25.75C23.7107 25.75 23.4472 25.9164 23.3229 26.1775L24 26.5ZM29.75 26.5V27.25C30.0266 27.25 30.2807 27.0978 30.4113 26.8539C30.5418 26.61 30.5275 26.3141 30.374 26.084L29.75 26.5ZM25.374 18.584L24.958 17.9599L23.7099 18.792L24.126 19.416L25.374 18.584ZM15.586 22.0986L20.836 32.0986L22.164 31.4014L16.914 21.4014L15.586 22.0986ZM22.1771 32.0725L24.6771 26.8225L23.3229 26.1775L20.8229 31.4275L22.1771 32.0725ZM24 27.25H29.75V25.75H24V27.25ZM30.374 26.084L25.374 18.584L24.126 19.416L29.126 26.916L30.374 26.084Z"
				fill="#1E293B"
			/>
			<path
				d="M11.75 32.25L12.414 32.5986C12.282 32.8501 12.0193 33.0054 11.7354 32.9999C11.4514 32.9943 11.195 32.8289 11.0729 32.5725L11.75 32.25ZM9.25 27V26.25C9.53928 26.25 9.80277 26.4164 9.92715 26.6775L9.25 27ZM3.5 27V27.75C3.2234 27.75 2.96926 27.5978 2.83874 27.3539C2.70823 27.11 2.72253 26.8141 2.87596 26.584L3.5 27ZM7.87596 19.084L8.29199 18.4599L9.54006 19.292L9.12404 19.916L7.87596 19.084ZM17.664 22.5986L12.414 32.5986L11.086 31.9014L16.336 21.9014L17.664 22.5986ZM11.0729 32.5725L8.57285 27.3225L9.92715 26.6775L12.4271 31.9275L11.0729 32.5725ZM9.25 27.75H3.5V26.25H9.25V27.75ZM2.87596 26.584L7.87596 19.084L9.12404 19.916L4.12404 27.416L2.87596 26.584Z"
				fill="#1E293B"
			/>
			<circle cx="16.75" cy="11.25" r="6" stroke="#FB6000" strokeWidth="1.5" />
			<circle
				cx="16.75"
				cy="11.25"
				r="10.5"
				stroke="#FB6000"
				strokeWidth="1.5"
			/>
		</svg>
	),
	iconLock: (props: IconProps) => (
		<svg
			width="24"
			height="31"
			viewBox="0 0 24 31"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect
				x="1.56641"
				y="12.375"
				width="21.5"
				height="17"
				rx="2.25"
				stroke="black"
				strokeWidth="1.5"
			/>
			<rect
				x="10.5664"
				y="18.375"
				width="3.5"
				height="6.5"
				rx="1.75"
				stroke="black"
				strokeWidth="1.5"
			/>
			<path
				d="M9.56641 8.125C9.56641 6.60622 10.7976 5.375 12.3164 5.375C13.8352 5.375 15.0664 6.60622 15.0664 8.125V12.375H9.56641V8.125Z"
				stroke="black"
				strokeWidth="1.5"
			/>
			<path
				d="M5.06641 7.625C5.06641 3.89708 8.08848 0.875 11.8164 0.875H12.8164C16.5443 0.875 19.5664 3.89708 19.5664 7.625V12.375H5.06641V7.625Z"
				stroke="black"
				strokeWidth="1.5"
			/>
		</svg>
	),
	save: (props: IconProps) => (
		<svg
			width="33"
			height="32"
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M24.6667 9.68359C27.8827 11.4775 30 14.5325 30 17.9997C30 20.7445 28.673 23.231 26.5244 25.0379C26.2023 25.3089 26 25.7013 26 26.1222V29.333H23.3334L22.275 27.8229C22.1107 27.5885 21.8155 27.4866 21.5383 27.5579C19.2331 28.1506 16.767 28.1506 14.4618 27.5579C14.1846 27.4866 13.8894 27.5885 13.7252 27.8229L12.6667 29.333H10V26.1535C10 25.7151 9.78451 25.3047 9.42356 25.0558C7.99051 24.0678 3.33337 22.1349 3.33337 20.0773V17.9997C3.33337 17.2106 3.93032 16.5711 4.66671 16.5711C5.47557 16.5711 6.13588 16.2569 6.40277 15.4211C7.16168 13.0447 8.94441 11.0162 11.3334 9.68359"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.2946 5.93807C21.1957 5.1754 20.3217 3.94318 18.7501 3.94315C16.924 3.94312 16.1556 4.95642 15.9997 5.46307C15.7565 6.14077 15.8051 7.53407 17.9455 7.68597C20.6211 7.87598 21.6929 8.19238 21.5566 9.83299C21.4201 11.4735 19.9287 11.828 18.7501 11.7899C17.5713 11.752 15.6429 11.2095 15.5681 9.75028M18.563 2.875V3.94678M18.563 11.7801V12.875"
				stroke="#FB6000"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M10.6664 16H10.6784"
				stroke="#1E293B"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	priceAlert: (props: IconProps) => (
		<svg
			width="33"
			height="32"
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M27.2279 18.2627L27.8129 18.8511C28.6586 19.7018 29.1334 20.8527 29.1334 22.0524V22.0524C29.1334 22.5656 28.8475 23.0377 28.3806 23.2448C26.2345 24.1965 22.0342 25.6005 16.3334 25.6005C10.6325 25.6005 6.4322 24.1965 4.28621 23.2448C3.81923 23.0377 3.53339 22.5656 3.53339 22.0524V22.0524C3.53339 20.8527 4.00813 19.7018 4.85392 18.8511L5.43885 18.2627C5.94422 17.7543 6.22812 17.0649 6.22812 16.3461V12.7253C6.22812 7.11144 10.7524 2.56055 16.3334 2.56055C17.0255 2.56055 17.7014 2.63055 18.3544 2.76388"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M26.8774 7.76055C26.7506 6.78434 25.6297 5.2071 23.6142 5.20706C21.2723 5.20702 20.2869 6.50405 20.087 7.15256C19.775 8.02 19.8374 9.80343 22.5824 9.99786C26.0137 10.2411 27.3883 10.6461 27.2134 12.746C27.0385 14.8459 25.1258 15.2996 23.6142 15.2509C22.1025 15.2023 19.6294 14.5079 19.5334 12.6402M23.3743 3.83984V5.21171M23.3743 15.2383V16.6398"
				stroke="#FB6000"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M20.1734 25.5996C20.1734 27.7204 18.1384 29.4396 15.6574 29.4396C13.1764 29.4396 11.2134 27.7204 11.2134 25.5996"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconMoney: (props: IconProps) => (
		<svg
			width="39"
			height="32"
			viewBox="0 0 39 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M33.8674 15.012C33.5709 14.7228 33.0961 14.7287 32.8068 15.0251L28.0932 19.8567C27.8039 20.1532 27.8098 20.628 28.1063 20.9173C28.4028 21.2065 28.8776 21.2007 29.1669 20.9042L33.3568 16.6095L37.6515 20.7994C37.948 21.0886 38.4228 21.0828 38.7121 20.7863C39.0013 20.4898 38.9955 20.015 38.699 19.7257L33.8674 15.012ZM7.35772 20.54C7.19825 20.1577 6.75907 19.9771 6.37679 20.1366C5.9945 20.296 5.81387 20.7352 5.97334 21.1175L7.35772 20.54ZM33.3437 15.5489C32.5937 15.5581 32.5937 15.5578 32.5937 15.5576C32.5937 15.5576 32.5937 15.5573 32.5937 15.5573C32.5937 15.5572 32.5937 15.5573 32.5937 15.5576C32.5937 15.5582 32.5937 15.5595 32.5938 15.5615C32.5938 15.5657 32.5938 15.5727 32.5938 15.5827C32.5937 15.6025 32.5934 15.6339 32.5926 15.6759C32.591 15.7601 32.587 15.887 32.5778 16.0511C32.5595 16.3796 32.5201 16.8556 32.4362 17.4338C32.2681 18.593 31.923 20.1477 31.2191 21.7441C29.8231 24.9102 27.022 28.2483 21.2714 29.0168L21.4701 30.5036C27.8479 29.6512 31.0333 25.8836 32.5916 22.3493C33.3649 20.5954 33.739 18.9013 33.9207 17.6491C34.0117 17.0217 34.055 16.5014 34.0755 16.1349C34.0858 15.9516 34.0903 15.8065 34.0923 15.7054C34.0933 15.6549 34.0937 15.6153 34.0937 15.5874C34.0938 15.5735 34.0938 15.5625 34.0937 15.5545C34.0937 15.5505 34.0937 15.5472 34.0937 15.5448C34.0937 15.5435 34.0937 15.5425 34.0936 15.5416C34.0936 15.5412 34.0936 15.5407 34.0936 15.5405C34.0936 15.54 34.0936 15.5396 33.3437 15.5489ZM21.2714 29.0168C16.8345 29.6098 13.708 28.2665 11.5181 26.4139C9.30374 24.5406 8.01544 22.1167 7.35772 20.54L5.97334 21.1175C6.67809 22.807 8.08192 25.4717 10.5493 27.5591C13.0411 29.6671 16.5861 31.1564 21.4701 30.5036L21.2714 29.0168Z"
				fill="black"
			/>
			<path
				d="M5.29974 17.7492C5.59755 18.0371 6.07236 18.0291 6.36024 17.7313L11.0517 12.8781C11.3396 12.5803 11.3315 12.1055 11.0337 11.8176C10.7359 11.5297 10.2611 11.5378 9.97319 11.8356L5.80303 16.1495L1.48913 11.9793C1.19131 11.6914 0.716508 11.6995 0.428618 11.9973C0.140729 12.2951 0.148775 12.7699 0.446587 13.0578L5.29974 17.7492ZM17.7277 2.50305L17.827 3.24644L17.7277 2.50305ZM31.9477 12.5332C32.0945 12.9205 32.5276 13.1154 32.9149 12.9685C33.3022 12.8217 33.4971 12.3887 33.3502 12.0014L31.9477 12.5332ZM5.82101 17.21C6.5709 17.1973 6.5709 17.1976 6.57091 17.1978C6.57091 17.1978 6.57091 17.198 6.57091 17.198C6.57091 17.1981 6.57091 17.198 6.5709 17.1976C6.57089 17.197 6.57088 17.1955 6.57086 17.1933C6.57081 17.1889 6.57076 17.1814 6.57074 17.1709C6.5707 17.1499 6.57079 17.1171 6.5714 17.073C6.57263 16.985 6.57591 16.8523 6.58427 16.6811C6.60101 16.3384 6.638 15.8424 6.71915 15.2401C6.88183 14.0328 7.21989 12.4145 7.91757 10.7551C9.30299 7.4598 12.0908 4.0131 17.827 3.24644L17.6283 1.75966C11.2361 2.61399 8.07062 6.52075 6.53481 10.1737C5.77187 11.9884 5.40733 13.7429 5.23258 15.0398C5.14501 15.6897 5.10458 16.2287 5.08606 16.608C5.07679 16.7977 5.073 16.9478 5.07155 17.0522C5.07082 17.1044 5.07068 17.1452 5.07074 17.1739C5.07077 17.1882 5.07085 17.1995 5.07092 17.2077C5.07096 17.2118 5.071 17.2151 5.07104 17.2176C5.07105 17.2188 5.07107 17.2199 5.07108 17.2207C5.07109 17.2212 5.0711 17.2216 5.0711 17.2219C5.07111 17.2223 5.07111 17.2227 5.82101 17.21ZM17.827 3.24644C22.435 2.63058 25.6442 4.18164 27.8642 6.25049C30.1102 8.34362 31.362 10.9887 31.9477 12.5332L33.3502 12.0014C32.7258 10.3546 31.3716 7.46872 28.8869 5.15314C26.3761 2.81328 22.7297 1.07786 17.6283 1.75966L17.827 3.24644Z"
				fill="black"
			/>
			<path
				d="M24.0488 11.8818C24.0488 10.929 23.7265 10.0621 23.2709 9.31272C21.9313 7.10954 18.9252 7.25942 16.7524 8.64762V8.64762C14.7225 9.94448 15.2273 13.1818 17.4728 14.0535C20.8665 15.3711 24.4193 17.3001 24.5488 19.6318C24.5488 20.8818 23.7988 23.8818 19.5488 23.8818C15.2988 23.8818 15.0488 19.6318 15.0488 19.6318"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M19.7988 5.38184V26.3818"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	iconPin: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.00033 8.66634C9.10489 8.66634 10.0003 7.77091 10.0003 6.66634C10.0003 5.56177 9.10489 4.66634 8.00033 4.66634C6.89576 4.66634 6.00033 5.56177 6.00033 6.66634C6.00033 7.77091 6.89576 8.66634 8.00033 8.66634Z"
				stroke={props.stroke || 'black'}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.95913 13.7305C7.31134 14.0573 7.48745 14.2207 7.70556 14.288C7.89 14.3449 8.11065 14.3449 8.29509 14.288C8.5132 14.2207 8.68931 14.0573 9.04152 13.7305C11.3194 11.6168 13.3337 9.2263 13.3337 6.66634C13.3337 3.72082 10.9458 1.33301 8.00033 1.33301C5.05481 1.33301 2.66699 3.72082 2.66699 6.66634C2.66699 9.2263 4.68123 11.6168 6.95913 13.7305Z"
				stroke={props.stroke || 'black'}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconPinBig: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.99935 8.66659C9.10392 8.66659 9.99935 7.77115 9.99935 6.66659C9.99935 5.56202 9.10392 4.66659 7.99935 4.66659C6.89478 4.66659 5.99935 5.56202 5.99935 6.66659C5.99935 7.77115 6.89478 8.66659 7.99935 8.66659Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.95815 13.7307C7.31036 14.0576 7.48647 14.221 7.70458 14.2883C7.88903 14.3452 8.10967 14.3452 8.29412 14.2883C8.51223 14.221 8.68833 14.0576 9.04054 13.7307C11.3184 11.617 13.3327 9.22654 13.3327 6.66659C13.3327 3.72107 10.9449 1.33325 7.99935 1.33325C5.05383 1.33325 2.66602 3.72107 2.66602 6.66659C2.66602 9.22654 4.68026 11.617 6.95815 13.7307Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	inPolicy: () => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<path
				d="M9 17.625C9.0736 19.4769 10.6169 21.0494 12.6844 20.9988C13.1654 20.9871 13.7599 20.8194 14.9489 20.484C17.8104 19.6769 20.2944 18.3204 20.8904 15.2816C21 14.723 21 14.0944 21 12.8373V11.1627C21 9.90564 21 9.27707 20.8904 8.71848C20.2944 5.67966 17.8104 4.32317 14.9489 3.51603C13.7599 3.18065 13.1654 3.01296 12.6844 3.00119C10.6169 2.95061 9.0736 4.52308 9 6.37502"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M14 12H3M14 12C14 11.2998 12.0057 9.99153 11.5 9.5M14 12C14 12.7002 12.0057 14.0085 11.5 14.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	outPolicy: () => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<path
				d="M15 17.625C14.9264 19.4769 13.3831 21.0494 11.3156 20.9988C10.8346 20.9871 10.2401 20.8194 9.05112 20.484C6.18961 19.6769 3.70555 18.3204 3.10956 15.2816C3 14.723 3 14.0944 3 12.8373V11.1627C3 9.90564 3 9.27707 3.10956 8.71848C3.70555 5.67966 6.18961 4.32317 9.05112 3.51603C10.2401 3.18065 10.8346 3.01296 11.3156 3.00119C13.3831 2.95061 14.9264 4.52308 15 6.37502"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M21 12H10M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconLens: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.5 17.5L22 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	lock: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8 11.0003V9.66699"
				stroke={props.stroke || '#64748B'}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M2.84651 12.5631C2.99643 13.6767 3.91872 14.549 5.04108 14.6006C5.98548 14.644 6.94484 14.6667 8.00131 14.6667C9.05777 14.6667 10.0171 14.644 10.9615 14.6006C12.0839 14.549 13.0062 13.6767 13.1561 12.5631C13.2539 11.8365 13.3346 11.0917 13.3346 10.3333C13.3346 9.57493 13.2539 8.8302 13.1561 8.10353C13.0062 6.99 12.0839 6.11766 10.9615 6.06606C10.0171 6.02265 9.05777 6 8.00131 6C6.94484 6 5.98548 6.02265 5.04108 6.06606C3.91872 6.11766 2.99643 6.99 2.84651 8.10353C2.74867 8.8302 2.66797 9.57493 2.66797 10.3333C2.66797 11.0917 2.74867 11.8365 2.84651 12.5631Z"
				stroke={props.stroke || '#64748B'}
				strokeWidth="1.5"
			/>
			<path
				d="M5 5.99967V4.33301C5 2.67615 6.34315 1.33301 8 1.33301C9.65687 1.33301 11 2.67615 11 4.33301V5.99967"
				stroke={props.stroke || '#64748B'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconCalendarFrom: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10.7231 3.51965C10.9855 3.51965 11.2031 3.30205 11.2031 3.03965V1.11965C11.2031 0.857248 10.9855 0.639648 10.7231 0.639648C10.4607 0.639648 10.2431 0.857248 10.2431 1.11965V3.03965C10.2431 3.30205 10.4607 3.51965 10.7231 3.51965Z"
				fill="black"
			/>
			<path
				d="M5.60203 3.51965C5.86443 3.51965 6.08203 3.30205 6.08203 3.03965V1.11965C6.08203 0.857248 5.86443 0.639648 5.60203 0.639648C5.33963 0.639648 5.12203 0.857248 5.12203 1.11965V3.03965C5.12203 3.30205 5.33963 3.51965 5.60203 3.51965Z"
				fill="black"
			/>
			<path
				d="M10.403 9.11958C10.4862 9.11958 10.5694 9.10039 10.6462 9.06839C10.7294 9.03639 10.7934 8.99158 10.8574 8.93398C10.9726 8.81238 11.043 8.64598 11.043 8.47958C11.043 8.31318 10.9726 8.14679 10.8574 8.02519C10.7934 7.96759 10.723 7.92277 10.6462 7.89077C10.4926 7.82677 10.3134 7.82677 10.1598 7.89077C10.083 7.92277 10.0126 7.96759 9.94857 8.02519C9.92297 8.05719 9.89098 8.08918 9.87178 8.12118C9.84618 8.15958 9.82696 8.19798 9.81416 8.23638C9.79496 8.27478 9.78216 8.31317 9.77576 8.35157C9.76936 8.39637 9.76297 8.44118 9.76297 8.47958C9.76297 8.64598 9.83337 8.81238 9.94857 8.93398C10.0126 8.99158 10.083 9.03639 10.1598 9.06839C10.2366 9.10039 10.3198 9.11958 10.403 9.11958Z"
				fill="black"
			/>
			<path
				d="M8.16078 9.11965C8.24398 9.11965 8.32718 9.10046 8.40398 9.06846C8.48718 9.03646 8.55118 8.99165 8.61518 8.93405C8.73038 8.81245 8.80078 8.64605 8.80078 8.47965C8.80078 8.44125 8.79439 8.39644 8.78799 8.35164C8.78159 8.31324 8.76879 8.27485 8.74959 8.23645C8.73679 8.19805 8.71757 8.15965 8.69197 8.12125C8.66637 8.08925 8.64078 8.05726 8.61518 8.02526C8.37838 7.78846 7.94959 7.78846 7.70639 8.02526C7.68079 8.05726 7.65519 8.08925 7.62959 8.12125C7.60399 8.15965 7.58477 8.19805 7.57197 8.23645C7.55277 8.27485 7.53997 8.31324 7.53357 8.35164C7.52717 8.39644 7.52078 8.44125 7.52078 8.47965C7.52078 8.64605 7.59119 8.81245 7.70639 8.93405C7.82799 9.04925 7.98798 9.11965 8.16078 9.11965Z"
				fill="black"
			/>
			<path
				d="M10.403 11.3598C10.4862 11.3598 10.5694 11.3406 10.6462 11.3086C10.723 11.2766 10.7934 11.2318 10.8574 11.1742C10.9726 11.0526 11.043 10.8862 11.043 10.7198C11.043 10.6814 11.0366 10.6366 11.0302 10.5982C11.0238 10.5534 11.011 10.515 10.9918 10.4766C10.979 10.4382 10.9598 10.3998 10.9342 10.3614C10.915 10.3294 10.883 10.2974 10.8574 10.2654C10.7934 10.2078 10.723 10.163 10.6462 10.131C10.4926 10.067 10.3134 10.067 10.1598 10.131C10.083 10.163 10.0126 10.2078 9.94857 10.2654C9.92297 10.2974 9.89098 10.3294 9.87178 10.3614C9.84618 10.3998 9.82696 10.4382 9.81416 10.4766C9.79496 10.515 9.78216 10.5534 9.77576 10.5982C9.76936 10.6366 9.76297 10.6814 9.76297 10.7198C9.76297 10.8862 9.83337 11.0526 9.94857 11.1742C10.0126 11.2318 10.083 11.2766 10.1598 11.3086C10.2366 11.3406 10.3198 11.3598 10.403 11.3598Z"
				fill="black"
			/>
			<path
				d="M2.72203 6.13773H13.602C13.8644 6.13773 14.082 5.92013 14.082 5.65773C14.082 5.39533 13.8644 5.17773 13.602 5.17773H2.72203C2.45963 5.17773 2.24203 5.39533 2.24203 5.65773C2.24203 5.92013 2.45963 6.13773 2.72203 6.13773Z"
				fill="black"
			/>
			<path
				d="M9.44234 14.3996H10.7223C13.0583 14.3996 14.4023 13.0556 14.4023 10.7196V5.27961C14.4023 2.94361 13.0583 1.59961 10.7223 1.59961H5.60234C3.26634 1.59961 1.92234 2.94361 1.92234 5.27961V7.51961C1.92234 7.78201 2.13994 7.99961 2.40234 7.99961C2.66474 7.99961 2.88234 7.78201 2.88234 7.51961V5.27961C2.88234 3.44921 3.77194 2.55961 5.60234 2.55961H10.7223C12.5527 2.55961 13.4423 3.44921 13.4423 5.27961V10.7196C13.4423 12.55 12.5527 13.4396 10.7223 13.4396H9.44234C9.17994 13.4396 8.96234 13.6572 8.96234 13.9196C8.96234 14.182 9.17994 14.3996 9.44234 14.3996Z"
				fill="black"
			/>
			<path
				d="M2.40297 9.60008C2.66537 9.60008 2.88297 9.81768 2.88297 10.0801L2.88297 12.3201C2.88297 12.7617 3.24137 13.1201 3.68297 13.1201L6.56297 13.1201C6.82537 13.1201 7.04297 13.3377 7.04297 13.6001C7.04297 13.8625 6.82537 14.0801 6.56297 14.0801L3.68297 14.0801C2.71017 14.0801 1.92297 13.2929 1.92297 12.3201L1.92297 10.0801C1.92297 9.81768 2.14057 9.60008 2.40297 9.60008Z"
				fill="black"
			/>
			<path
				d="M4.96328 11.5195C5.07208 11.5195 5.18087 11.5579 5.27047 11.6283L7.19047 13.2283C7.29927 13.3179 7.36328 13.4523 7.36328 13.5995C7.36328 13.7467 7.29927 13.8747 7.19047 13.9707L5.27047 15.5707C5.06567 15.7435 4.76487 15.7115 4.59207 15.5067C4.41927 15.3019 4.45129 15.0011 4.65609 14.8283L6.13449 13.5995L4.65609 12.3707C4.45129 12.1979 4.42567 11.8971 4.59207 11.6923C4.68807 11.5771 4.82888 11.5195 4.96328 11.5195Z"
				fill="black"
			/>
		</svg>
	),
	iconCalendarTo: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10.7231 3.51965C10.9855 3.51965 11.2031 3.30205 11.2031 3.03965V1.11965C11.2031 0.857248 10.9855 0.639648 10.7231 0.639648C10.4607 0.639648 10.2431 0.857248 10.2431 1.11965V3.03965C10.2431 3.30205 10.4607 3.51965 10.7231 3.51965Z"
				fill="black"
			/>
			<path
				d="M5.60203 3.51965C5.86443 3.51965 6.08203 3.30205 6.08203 3.03965V1.11965C6.08203 0.857248 5.86443 0.639648 5.60203 0.639648C5.33963 0.639648 5.12203 0.857248 5.12203 1.11965V3.03965C5.12203 3.30205 5.33963 3.51965 5.60203 3.51965Z"
				fill="black"
			/>
			<path
				d="M5.92125 9.11958C5.83805 9.11958 5.75485 9.10039 5.67805 9.06839C5.59485 9.03639 5.53086 8.99158 5.46686 8.93398C5.35166 8.81238 5.28125 8.64598 5.28125 8.47958C5.28125 8.31318 5.35166 8.14679 5.46686 8.02519C5.53086 7.96759 5.60125 7.92277 5.67805 7.89077C5.83165 7.82677 6.01085 7.82677 6.16445 7.89077C6.24125 7.92277 6.31164 7.96759 6.37564 8.02519C6.40124 8.05719 6.43324 8.08918 6.45244 8.12118C6.47804 8.15958 6.49726 8.19798 6.51006 8.23638C6.52926 8.27478 6.54206 8.31317 6.54846 8.35157C6.55486 8.39637 6.56125 8.44118 6.56125 8.47958C6.56125 8.64598 6.49084 8.81238 6.37564 8.93398C6.31164 8.99158 6.24125 9.03639 6.16445 9.06839C6.08765 9.10039 6.00445 9.11958 5.92125 9.11958Z"
				fill="black"
			/>
			<path
				d="M8.16344 9.11965C8.08024 9.11965 7.99703 9.10046 7.92023 9.06846C7.83703 9.03646 7.77304 8.99165 7.70904 8.93405C7.59384 8.81245 7.52344 8.64605 7.52344 8.47965C7.52344 8.44125 7.52983 8.39644 7.53623 8.35164C7.54263 8.31324 7.55543 8.27485 7.57463 8.23645C7.58743 8.19805 7.60665 8.15965 7.63225 8.12125C7.65785 8.08925 7.68344 8.05726 7.70904 8.02526C7.94584 7.78846 8.37463 7.78846 8.61783 8.02526C8.64343 8.05726 8.66903 8.08925 8.69463 8.12125C8.72023 8.15965 8.73945 8.19805 8.75225 8.23645C8.77145 8.27485 8.78424 8.31324 8.79064 8.35164C8.79704 8.39644 8.80344 8.44125 8.80344 8.47965C8.80344 8.64605 8.73303 8.81245 8.61783 8.93405C8.49623 9.04925 8.33624 9.11965 8.16344 9.11965Z"
				fill="black"
			/>
			<path
				d="M5.92125 11.3598C5.83805 11.3598 5.75485 11.3406 5.67805 11.3086C5.60125 11.2766 5.53086 11.2318 5.46686 11.1742C5.35166 11.0526 5.28125 10.8862 5.28125 10.7198C5.28125 10.6814 5.28764 10.6366 5.29404 10.5982C5.30044 10.5534 5.31324 10.515 5.33244 10.4766C5.34524 10.4382 5.36446 10.3998 5.39006 10.3614C5.40926 10.3294 5.44126 10.2974 5.46686 10.2654C5.53086 10.2078 5.60125 10.163 5.67805 10.131C5.83165 10.067 6.01085 10.067 6.16445 10.131C6.24125 10.163 6.31164 10.2078 6.37564 10.2654C6.40124 10.2974 6.43324 10.3294 6.45244 10.3614C6.47804 10.3998 6.49726 10.4382 6.51006 10.4766C6.52926 10.515 6.54206 10.5534 6.54846 10.5982C6.55486 10.6366 6.56125 10.6814 6.56125 10.7198C6.56125 10.8862 6.49084 11.0526 6.37564 11.1742C6.31164 11.2318 6.24125 11.2766 6.16445 11.3086C6.08765 11.3406 6.00445 11.3598 5.92125 11.3598Z"
				fill="black"
			/>
			<path
				d="M2.72203 6.13773H13.602C13.8644 6.13773 14.082 5.92013 14.082 5.65773C14.082 5.39533 13.8644 5.17773 13.602 5.17773H2.72203C2.45963 5.17773 2.24203 5.39533 2.24203 5.65773C2.24203 5.92013 2.45963 6.13773 2.72203 6.13773Z"
				fill="black"
			/>
			<path
				d="M6.88188 14.3996H5.60187C3.26587 14.3996 1.92188 13.0556 1.92188 10.7196V5.27961C1.92188 2.94361 3.26587 1.59961 5.60187 1.59961H10.7219C13.0579 1.59961 14.4019 2.94361 14.4019 5.27961V7.51961C14.4019 7.78201 14.1843 7.99961 13.9219 7.99961C13.6595 7.99961 13.4419 7.78201 13.4419 7.51961V5.27961C13.4419 3.44921 12.5523 2.55961 10.7219 2.55961H5.60187C3.77148 2.55961 2.88187 3.44921 2.88187 5.27961V10.7196C2.88187 12.55 3.77148 13.4396 5.60187 13.4396H6.88188C7.14427 13.4396 7.36188 13.6572 7.36188 13.9196C7.36188 14.182 7.14427 14.3996 6.88188 14.3996Z"
				fill="black"
			/>
			<path
				d="M13.9212 9.60008C13.6588 9.60008 13.4412 9.81768 13.4412 10.0801L13.4412 12.3201C13.4412 12.7617 13.0828 13.1201 12.6412 13.1201L9.76125 13.1201C9.49885 13.1201 9.28125 13.3377 9.28125 13.6001C9.28125 13.8625 9.49885 14.0801 9.76125 14.0801L12.6412 14.0801C13.614 14.0801 14.4012 13.2929 14.4012 12.3201L14.4012 10.0801C14.4012 9.81768 14.1836 9.60008 13.9212 9.60008Z"
				fill="black"
			/>
			<path
				d="M11.3609 11.5195C11.2521 11.5195 11.1433 11.5579 11.0537 11.6283L9.13375 13.2283C9.02495 13.3179 8.96094 13.4523 8.96094 13.5995C8.96094 13.7467 9.02495 13.8747 9.13375 13.9707L11.0537 15.5707C11.2585 15.7435 11.5593 15.7115 11.7321 15.5067C11.9049 15.3019 11.8729 15.0011 11.6681 14.8283L10.1897 13.5995L11.6681 12.3707C11.8729 12.1979 11.8985 11.8971 11.7321 11.6923C11.6361 11.5771 11.4953 11.5195 11.3609 11.5195Z"
				fill="black"
			/>
		</svg>
	),
	iconGuests: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.97038 4.75634C2.97038 6.64367 4.50638 8.17968 6.39438 8.17968H6.41704C7.32838 8.17634 8.18504 7.81834 8.82638 7.17101C9.46904 6.52434 9.82171 5.66567 9.81771 4.75634C9.81771 2.86901 8.28171 1.33301 6.39438 1.33301C4.50638 1.33301 2.97038 2.86901 2.97038 4.75634ZM3.97038 4.75634C3.97038 3.42034 5.05771 2.33301 6.39438 2.33301C7.73038 2.33301 8.81771 3.42034 8.81771 4.75834C8.82038 5.40234 8.57171 6.00967 8.11704 6.46634C7.66304 6.92434 7.05771 7.17701 6.41504 7.17968H6.39438C5.05771 7.17968 3.97038 6.09234 3.97038 4.75634Z"
				fill="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.33301 11.679C1.33301 14.0377 5.01034 14.0377 6.39434 14.0377C7.64634 14.0377 11.4557 14.0377 11.4557 11.6657C11.4557 9.54903 8.56701 9.30436 6.39434 9.30436C5.14234 9.30436 1.33301 9.30436 1.33301 11.679ZM2.33301 11.679C2.33301 10.5424 4.54167 10.3044 6.39434 10.3044C9.08901 10.3044 10.4557 10.7624 10.4557 11.6657C10.4557 12.5757 9.08901 13.0377 6.39434 13.0377C3.69967 13.0377 2.33301 12.5804 2.33301 11.679Z"
				fill="black"
			/>
			<path
				d="M10.9881 7.42085C10.7428 7.42085 10.5288 7.24018 10.4934 6.99018C10.4554 6.71685 10.6454 6.46352 10.9188 6.42552C11.7508 6.30885 12.3788 5.58685 12.3801 4.74552C12.3801 3.90952 11.7814 3.20419 10.9581 3.06952C10.6854 3.02419 10.5008 2.76752 10.5454 2.49485C10.5901 2.22219 10.8481 2.03885 11.1194 2.08219C12.4294 2.29685 13.3801 3.41752 13.3801 4.74619C13.3774 6.08285 12.3794 7.23085 11.0581 7.41619C11.0348 7.41952 11.0114 7.42085 10.9881 7.42085Z"
				fill="black"
			/>
			<path
				d="M12.7962 11.9843C12.8715 12.1836 13.0615 12.307 13.2635 12.307C13.3228 12.307 13.3828 12.2963 13.4408 12.2743C14.4428 11.895 14.6528 11.237 14.6528 10.751C14.6528 10.0983 14.2748 9.26296 12.4708 8.99296C12.2028 8.95763 11.9435 9.14096 11.9022 9.41429C11.8615 9.68696 12.0502 9.94163 12.3235 9.98296C13.2055 10.1143 13.6528 10.373 13.6528 10.751C13.6528 10.863 13.6528 11.125 13.0862 11.3396C12.8282 11.437 12.6982 11.7263 12.7962 11.9843Z"
				fill="black"
			/>
		</svg>
	),
	minus: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5 12H19"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	plus: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.99967 3.33337V12.6667M3.33301 8.00004H12.6663"
				stroke={props.stroke || 'black'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	caret: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M4 6L8 10L12 6"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	letter: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.33301 4L5.94169 6.61131C7.64074 7.574 8.35861 7.574 10.0577 6.61131L14.6663 4"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M1.34352 8.98341C1.3871 11.0271 1.40889 12.0489 2.16298 12.8059C2.91706 13.5629 3.96656 13.5892 6.06556 13.6419C7.35921 13.6745 8.64014 13.6745 9.93381 13.6419C12.0328 13.5892 13.0823 13.5629 13.8364 12.8059C14.5905 12.0489 14.6123 11.0271 14.6558 8.98341C14.6699 8.32627 14.6699 7.67307 14.6558 7.01594C14.6123 4.97225 14.5905 3.9504 13.8364 3.19345C13.0823 2.4365 12.0328 2.41013 9.93381 2.35739C8.64014 2.32488 7.35921 2.32488 6.06555 2.35738C3.96656 2.41012 2.91706 2.43648 2.16297 3.19344C1.40889 3.9504 1.3871 4.97224 1.34351 7.01594C1.3295 7.67307 1.32951 8.32627 1.34352 8.98341Z"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	map: (props: IconProps) => (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
			<path d="M3.501 2.79723L2.68242 3.27209C2.02362 3.65425 1.69422 3.84533 1.51312 4.16322C1.33203 4.4811 1.33203 4.86822 1.33203 5.64245V11.0855C1.33203 12.1028 1.33203 12.6115 1.5602 12.8945C1.71204 13.0829 1.9248 13.2095 2.16003 13.2515C2.51354 13.3146 2.94635 13.0635 3.81194 12.5614C4.39974 12.2204 4.96544 11.8663 5.66861 11.9623C5.98847 12.006 6.29357 12.1577 6.90376 12.4611L9.44636 13.7253C9.9963 13.9988 10.0014 14 10.613 14H11.9987C13.2558 14 13.8843 14 14.2748 13.6009C14.6654 13.2017 14.6654 12.5593 14.6654 11.2745V6.781C14.6654 5.49615 14.6654 4.85373 14.2748 4.45459C13.8843 4.05544 13.2558 4.05544 11.9987 4.05544H10.613C10.0014 4.05544 9.9963 4.05426 9.44636 3.7808L7.2253 2.67642C6.29792 2.21531 5.83424 1.98476 5.34028 2.00078C4.84632 2.01681 4.39788 2.27695 3.501 2.79723Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5.33203 2V11.6667" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M10 4.33398V13.6673" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	),
	list: (props: IconProps) => (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
			<path d="M5.33203 3.33398H13.332" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" />
			<path d="M2.66797 3.33398H2.67396" stroke="#475569" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M2.66797 8H2.67396" stroke="#475569" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M2.66797 12.666H2.67396" stroke="#475569" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5.33203 8H13.332" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" />
			<path d="M5.33203 12.666H13.332" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" />
		</svg>
	),
	logoSmall: (props: IconProps) => (
		<svg
			width="61"
			height="31"
			viewBox="0 0 61 31"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 10.2459L0 25.6106C0 26.4661 0.726348 27.1596 1.62234 27.1596L18.9273 27.1596C19.8233 27.1596 20.5497 26.4661 20.5497 25.6106L20.5497 10.2459C20.5497 9.83506 20.3788 9.44106 20.0745 9.15057L11.422 0.889238C10.7885 0.284316 9.76124 0.284316 9.12768 0.889238L0.475174 9.15057C0.170926 9.44106 0 9.83506 0 10.2459ZM10.2748 5.4736C10.7975 5.4736 11.2212 5.06905 11.2212 4.57001C11.2212 4.07098 10.7975 3.66643 10.2748 3.66643C9.75218 3.66643 9.32848 4.07098 9.32848 4.57001C9.32848 5.06905 9.75218 5.4736 10.2748 5.4736Z"
				fill="#FB6000"
			/>
			<path
				d="M4.09073 12.6075C3.92769 12.7529 3.83594 12.9512 3.83594 13.158L3.83594 22.6416C3.83594 23.0692 4.22021 23.4158 4.69424 23.4158H7.91286C8.38689 23.4158 8.77116 23.0692 8.77116 22.6416L8.77116 19.0286C8.77116 18.601 9.15544 18.2543 9.62947 18.2543H10.2732H10.9169C11.3909 18.2543 11.7752 18.601 11.7752 19.0286L11.7752 22.6416C11.7752 23.0692 12.1595 23.4158 12.6335 23.4158L15.8521 23.4158C16.3262 23.4158 16.7104 23.0692 16.7104 22.6416V13.158C16.7104 12.9512 16.6187 12.7529 16.4557 12.6075L10.8767 7.63094C10.5423 7.33265 10.0041 7.33265 9.66968 7.63094L4.09073 12.6075Z"
				fill="white"
			/>
			<path
				d="M0 29.3545C0 28.998 0.302645 28.709 0.675977 28.709L19.8737 28.709C20.247 28.709 20.5497 28.998 20.5497 29.3545C20.5497 29.711 20.247 30 19.8737 30L0.675977 30C0.302645 30 0 29.711 0 29.3545Z"
				fill="#FB6000"
			/>
			<path
				d="M53.8402 30.1078C53.4865 30.1078 53.1478 30.0477 52.8241 29.9275C52.5004 29.8013 52.2187 29.6541 51.9789 29.4858V28.2959C52.2427 28.4882 52.5394 28.6505 52.8691 28.7827C53.2048 28.9149 53.5525 28.981 53.9121 28.981C54.1639 28.981 54.3707 28.9239 54.5326 28.8097C54.7004 28.6955 54.7843 28.5393 54.7843 28.341C54.7843 28.2388 54.7484 28.1487 54.6764 28.0705C54.6105 27.9864 54.5236 27.9143 54.4157 27.8542C54.3138 27.7881 54.2029 27.734 54.083 27.6919L53.1568 27.3314C52.8451 27.2112 52.6023 27.0669 52.4285 26.8987C52.2547 26.7304 52.1318 26.5441 52.0598 26.3398C51.9939 26.1294 51.9609 25.9071 51.9609 25.6727C51.9609 25.3001 52.0598 24.9786 52.2577 24.7082C52.4615 24.4317 52.7252 24.2184 53.0489 24.0681C53.3786 23.9179 53.7293 23.8428 54.101 23.8428C54.4546 23.8428 54.7754 23.8909 55.0631 23.987C55.3508 24.0832 55.5906 24.1943 55.7824 24.3205V25.5104C55.5666 25.3722 55.3268 25.249 55.0631 25.1409C54.8053 25.0267 54.5206 24.9696 54.2089 24.9696C54.053 24.9696 53.9032 24.9966 53.7593 25.0507C53.6154 25.1048 53.4955 25.1829 53.3996 25.2851C53.3097 25.3872 53.2647 25.5165 53.2647 25.6727C53.2647 25.871 53.3517 26.0243 53.5255 26.1324C53.6993 26.2346 53.9121 26.3398 54.1639 26.4479L54.8833 26.7544C55.3089 26.9347 55.6206 27.1481 55.8184 27.3945C56.0222 27.6348 56.1241 27.9293 56.1241 28.2779C56.1241 28.6384 56.0192 28.957 55.8094 29.2334C55.6056 29.5038 55.3298 29.7172 54.9822 29.8734C54.6405 30.0297 54.2598 30.1078 53.8402 30.1078Z"
				fill="#FB6000"
			/>
			<path
				d="M46.8203 29.9996V23.96H51.1094V25.0417H48.0702V28.8909H51.1094V29.9996H46.8203ZM47.5486 27.4485V26.3939H50.7587V27.4485H47.5486Z"
				fill="#FB6000"
			/>
			<path
				d="M43.9565 30.1353C43.5249 30.1353 43.1173 30.0602 42.7336 29.9099C42.356 29.7537 42.0173 29.5373 41.7176 29.2609C41.4238 28.9784 41.1931 28.6449 41.0252 28.2603C40.8574 27.8697 40.7734 27.443 40.7734 26.9802C40.7734 26.5115 40.8574 26.0848 41.0252 25.7002C41.1931 25.3156 41.4238 24.9851 41.7176 24.7086C42.0173 24.4262 42.356 24.2098 42.7336 24.0596C43.1173 23.9033 43.5249 23.8252 43.9565 23.8252C44.3342 23.8252 44.6609 23.8793 44.9366 23.9875C45.2124 24.0896 45.4521 24.2308 45.656 24.4111V25.6732C45.5121 25.559 45.3622 25.4538 45.2064 25.3576C45.0505 25.2555 44.8767 25.1713 44.6848 25.1052C44.493 25.0391 44.2622 25.0061 43.9925 25.0061C43.6328 25.0061 43.3061 25.0932 43.0124 25.2675C42.7187 25.4358 42.4849 25.6701 42.311 25.9706C42.1372 26.2651 42.0503 26.6016 42.0503 26.9802C42.0503 27.3528 42.1372 27.6894 42.311 27.9899C42.4849 28.2843 42.7187 28.5187 43.0124 28.693C43.3061 28.8613 43.6328 28.9454 43.9925 28.9454C44.3941 28.9454 44.7298 28.8823 44.9996 28.7561C45.2753 28.6299 45.5241 28.4796 45.7459 28.3054V29.5223C45.5421 29.7026 45.2873 29.8498 44.9816 29.964C44.6759 30.0782 44.3342 30.1353 43.9565 30.1353Z"
				fill="#FB6000"
			/>
			<path
				d="M37.6157 29.9996V23.96H38.8656V29.9996H37.6157ZM36.5547 29.9996V28.9179H39.9266V29.9996H36.5547ZM36.5547 25.0417V23.96H39.9266V25.0417H36.5547Z"
				fill="#FB6000"
			/>
			<path
				d="M30.7773 29.9996V23.96H33.2231C33.5048 23.96 33.7806 23.999 34.0503 24.0771C34.3201 24.1553 34.5629 24.2755 34.7787 24.4377C35.0005 24.594 35.1743 24.7953 35.3002 25.0417C35.4321 25.2881 35.498 25.5796 35.498 25.9161C35.498 26.2887 35.3991 26.6042 35.2013 26.8626C35.0095 27.115 34.7547 27.3073 34.437 27.4395C34.1253 27.5657 33.7896 27.6288 33.4299 27.6288C33.34 27.6288 33.2231 27.6198 33.0792 27.6018C32.9414 27.5777 32.7945 27.5537 32.6386 27.5297C32.4828 27.4996 32.3359 27.4726 32.198 27.4485C32.0662 27.4185 31.9643 27.3945 31.8923 27.3764V26.6102C32.0542 26.6703 32.234 26.7184 32.4318 26.7544C32.6356 26.7905 32.8395 26.8085 33.0433 26.8085C33.4029 26.8085 33.6877 26.7274 33.8975 26.5651C34.1133 26.4029 34.2212 26.1865 34.2212 25.9161C34.2212 25.6216 34.1073 25.4023 33.8795 25.258C33.6577 25.1138 33.3849 25.0417 33.0612 25.0417H32.0272V29.9996H30.7773ZM34.1223 29.9996L31.8923 27.3764L32.9713 26.9888L35.7678 29.9996H34.1223Z"
				fill="#FB6000"
			/>
			<path
				d="M24.9805 29.9996V23.96H27.4712C27.7529 23.96 28.0287 24.011 28.2984 24.1132C28.5682 24.2154 28.811 24.3656 29.0268 24.5639C29.2486 24.7562 29.4224 24.9936 29.5483 25.2761C29.6802 25.5525 29.7461 25.871 29.7461 26.2316C29.7461 26.6703 29.6412 27.0549 29.4314 27.3854C29.2276 27.71 28.9548 27.9654 28.6131 28.1517C28.2714 28.332 27.8998 28.4221 27.4982 28.4221C27.1745 28.4221 26.8927 28.3921 26.6529 28.332C26.4132 28.2719 26.2213 28.1967 26.0775 28.1066V27.079C26.2093 27.1451 26.3832 27.2082 26.599 27.2683C26.8208 27.3223 27.0516 27.3494 27.2913 27.3494C27.651 27.3494 27.9358 27.2502 28.1456 27.0519C28.3614 26.8476 28.4693 26.5741 28.4693 26.2316C28.4693 25.9852 28.4123 25.7839 28.2984 25.6276C28.1905 25.4654 28.0437 25.3422 27.8578 25.258C27.678 25.1739 27.4802 25.1318 27.2644 25.1318H26.2303V29.9996H24.9805Z"
				fill="#FB6000"
			/>
			<path
				d="M56.3129 20.8773C55.9592 20.8773 55.6205 20.8172 55.2968 20.697C54.9731 20.5708 54.6914 20.4236 54.4516 20.2553V19.0654C54.7153 19.2577 55.0121 19.42 55.3418 19.5522C55.6775 19.6844 56.0251 19.7505 56.3848 19.7505C56.6366 19.7505 56.8434 19.6934 57.0052 19.5793C57.1731 19.4651 57.257 19.3088 57.257 19.1105C57.257 19.0083 57.221 18.9182 57.1491 18.8401C57.0832 18.7559 56.9962 18.6838 56.8883 18.6237C56.7864 18.5576 56.6755 18.5035 56.5556 18.4615L55.6295 18.1009C55.3178 17.9807 55.075 17.8365 54.9012 17.6682C54.7273 17.4999 54.6044 17.3136 54.5325 17.1093C54.4666 16.899 54.4336 16.6766 54.4336 16.4422C54.4336 16.0696 54.5325 15.7481 54.7303 15.4777C54.9341 15.2012 55.1979 14.9879 55.5216 14.8377C55.8513 14.6874 56.202 14.6123 56.5736 14.6123C56.9273 14.6123 57.248 14.6604 57.5357 14.7565C57.8235 14.8527 58.0633 14.9639 58.2551 15.0901V16.28C58.0393 16.1418 57.7995 16.0186 57.5357 15.9104C57.278 15.7962 56.9932 15.7391 56.6815 15.7391C56.5257 15.7391 56.3758 15.7662 56.2319 15.8202C56.0881 15.8743 55.9682 15.9524 55.8723 16.0546C55.7824 16.1568 55.7374 16.286 55.7374 16.4422C55.7374 16.6405 55.8243 16.7938 55.9982 16.902C56.172 17.0041 56.3848 17.1093 56.6366 17.2175L57.3559 17.524C57.7815 17.7043 58.0932 17.9176 58.2911 18.164C58.4949 18.4044 58.5968 18.6988 58.5968 19.0474C58.5968 19.408 58.4919 19.7265 58.2821 20.0029C58.0782 20.2734 57.8025 20.4867 57.4548 20.643C57.1131 20.7992 56.7325 20.8773 56.3129 20.8773Z"
				fill="#FB6000"
			/>
			<path
				d="M49.5273 20.7692V14.7295H50.7772V19.6424H53.7445V20.7692H49.5273Z"
				fill="#FB6000"
			/>
			<path
				d="M43.9414 20.7692V14.7295H48.2305V15.8112H45.1913V19.6604H48.2305V20.7692H43.9414ZM44.6697 18.2181V17.1634H47.8798V18.2181H44.6697Z"
				fill="#FB6000"
			/>
			<path
				d="M39.8796 20.7692V14.7295H41.1295V20.7692H39.8796ZM38.0273 15.8112V14.7295H42.9818V15.8112H38.0273Z"
				fill="#FB6000"
			/>
			<path
				d="M34.5428 20.9048C34.1112 20.9048 33.7036 20.8297 33.3199 20.6795C32.9423 20.5232 32.6066 20.3069 32.3129 20.0304C32.0251 19.748 31.7973 19.4144 31.6295 19.0298C31.4676 18.6392 31.3867 18.2125 31.3867 17.7498C31.3867 17.281 31.4676 16.8543 31.6295 16.4697C31.7973 16.0851 32.0251 15.7546 32.3129 15.4781C32.6066 15.1957 32.9423 14.9793 33.3199 14.8291C33.7036 14.6729 34.1112 14.5947 34.5428 14.5947C34.9744 14.5947 35.3791 14.6729 35.7567 14.8291C36.1344 14.9793 36.4671 15.1957 36.7548 15.4781C37.0485 15.7546 37.2763 16.0851 37.4382 16.4697C37.606 16.8543 37.6899 17.281 37.6899 17.7498C37.6899 18.2125 37.606 18.6392 37.4382 19.0298C37.2763 19.4144 37.0485 19.748 36.7548 20.0304C36.4671 20.3069 36.1344 20.5232 35.7567 20.6795C35.3791 20.8297 34.9744 20.9048 34.5428 20.9048ZM34.5428 19.7149C34.9025 19.7149 35.2232 19.6308 35.5049 19.4625C35.7867 19.2882 36.0085 19.0539 36.1703 18.7594C36.3322 18.4649 36.4131 18.1284 36.4131 17.7498C36.4131 17.3712 36.3322 17.0346 36.1703 16.7402C36.0085 16.4397 35.7867 16.2053 35.5049 16.037C35.2232 15.8628 34.9025 15.7756 34.5428 15.7756C34.1832 15.7756 33.8624 15.8628 33.5807 16.037C33.299 16.2053 33.0742 16.4397 32.9063 16.7402C32.7445 17.0406 32.6635 17.3772 32.6635 17.7498C32.6635 18.1224 32.7445 18.4589 32.9063 18.7594C33.0682 19.0539 33.29 19.2882 33.5717 19.4625C33.8594 19.6308 34.1832 19.7149 34.5428 19.7149Z"
				fill="#FB6000"
			/>
			<path
				d="M29.0736 20.7692V14.7295H30.3145V20.7692H29.0736ZM25.0273 20.7692V14.7295H26.2772V20.7692H25.0273ZM26.1243 18.3172V17.1904H29.3254V18.3172H26.1243Z"
				fill="#FB6000"
			/>
			<path
				d="M42.575 11.5387V5.49902H43.8248V11.5387H42.575ZM40.7227 6.58075V5.49902H45.6771V6.58075H40.7227Z"
				fill="#FB6000"
			/>
			<path
				d="M37.9652 11.6469C37.6115 11.6469 37.2728 11.5868 36.9491 11.4666C36.6254 11.3404 36.3437 11.1931 36.1039 11.0249V9.83496C36.3677 10.0273 36.6644 10.1895 36.9941 10.3217C37.3298 10.454 37.6775 10.5201 38.0371 10.5201C38.2889 10.5201 38.4957 10.463 38.6576 10.3488C38.8254 10.2346 38.9093 10.0784 38.9093 9.88003C38.9093 9.77787 38.8734 9.68773 38.8014 9.6096C38.7355 9.52547 38.6486 9.45335 38.5407 9.39325C38.4388 9.32715 38.3279 9.27306 38.208 9.23099L37.2818 8.87042C36.9701 8.75023 36.7273 8.60599 36.5535 8.43773C36.3797 8.26946 36.2568 8.08316 36.1848 7.87883C36.1189 7.66849 36.0859 7.44614 36.0859 7.21176C36.0859 6.83917 36.1848 6.51765 36.3827 6.24722C36.5865 5.97078 36.8502 5.75744 37.1739 5.6072C37.5036 5.45696 37.8543 5.38184 38.226 5.38184C38.5796 5.38184 38.9004 5.42991 39.1881 5.52607C39.4758 5.62222 39.7156 5.7334 39.9074 5.8596V7.0495C39.6916 6.91128 39.4518 6.78809 39.1881 6.67991C38.9303 6.56573 38.6456 6.50864 38.3339 6.50864C38.178 6.50864 38.0282 6.53568 37.8843 6.58977C37.7404 6.64386 37.6205 6.72198 37.5246 6.82414C37.4347 6.92631 37.3897 7.05551 37.3897 7.21176C37.3897 7.41008 37.4767 7.56333 37.6505 7.6715C37.8243 7.77366 38.0371 7.87883 38.2889 7.987L39.0083 8.29349C39.4339 8.47378 39.7456 8.68712 39.9434 8.93352C40.1472 9.1739 40.2491 9.46837 40.2491 9.81693C40.2491 10.1775 40.1442 10.496 39.9344 10.7725C39.7306 11.0429 39.4548 11.2562 39.1072 11.4125C38.7655 11.5687 38.3848 11.6469 37.9652 11.6469Z"
				fill="#FB6000"
			/>
			<path
				d="M30.9453 11.5387V5.49902H35.2344V6.58075H32.1952V10.4299H35.2344V11.5387H30.9453ZM31.6736 8.98761V7.93292H34.8837V8.98761H31.6736Z"
				fill="#FB6000"
			/>
			<path
				d="M27.4551 11.6466C27.1914 11.6466 26.9066 11.6345 26.6009 11.6105C26.3012 11.5865 26.0104 11.5564 25.7287 11.5204C25.453 11.4843 25.2192 11.4452 25.0273 11.4032V5.57985C25.369 5.50774 25.7317 5.45365 26.1153 5.41759C26.505 5.37553 26.9006 5.35449 27.3023 5.35449C27.7878 5.35449 28.2014 5.42961 28.5431 5.57985C28.8908 5.72408 29.1576 5.92541 29.3434 6.18382C29.5352 6.44223 29.6311 6.73971 29.6311 7.07625C29.6311 7.37673 29.5502 7.64416 29.3883 7.87853C29.2325 8.11291 29.0347 8.29319 28.7949 8.4194C28.9747 8.46747 29.1486 8.5486 29.3164 8.66279C29.4843 8.77096 29.6221 8.91819 29.73 9.10449C29.8379 9.28478 29.8919 9.51615 29.8919 9.7986C29.8919 10.1351 29.796 10.4446 29.6041 10.7271C29.4123 11.0035 29.1336 11.2259 28.7679 11.3942C28.4082 11.5624 27.9706 11.6466 27.4551 11.6466ZM27.4281 10.5648C27.7758 10.5648 28.0546 10.4867 28.2644 10.3305C28.4742 10.1742 28.5791 9.97288 28.5791 9.72649C28.5791 9.46807 28.4712 9.27877 28.2554 9.15858C28.0396 9.03839 27.7638 8.97829 27.4281 8.97829H26.0704V8.0498H27.4461C27.7518 8.0498 27.9856 7.97468 28.1475 7.82444C28.3093 7.6742 28.3903 7.4819 28.3903 7.24752C28.3903 7.08526 28.3423 6.94704 28.2464 6.83286C28.1565 6.71267 28.0336 6.61952 27.8777 6.55341C27.7279 6.4873 27.551 6.45425 27.3472 6.45425C27.1494 6.45425 26.9576 6.46327 26.7717 6.4813C26.5859 6.49331 26.4211 6.51435 26.2772 6.5444V10.4567C26.3911 10.4807 26.52 10.5017 26.6638 10.5198C26.8137 10.5378 26.9576 10.5498 27.0954 10.5558C27.2333 10.5618 27.3442 10.5648 27.4281 10.5648Z"
				fill="#FB6000"
			/>
		</svg>
	),
	globeBig: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
			<path
				d="M8 12C8 18 12 22 12 22C12 22 16 18 16 12C16 6 12 2 12 2C12 2 8 6 8 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M21 12H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	chevron: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9 18L15 12L9 6"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	chevronSmall: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6 12L10 8L6 4"
				stroke={props.stroke || 'black'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	lensSmall: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
				stroke="#1E293B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	star: (props: IconProps) => (
		<svg
			width="14"
			height="13"
			viewBox="0 0 14 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6.28671 1.19529C6.51122 0.504303 7.48878 0.504305 7.71329 1.19529L8.62773 4.00963C8.72813 4.31864 9.0161 4.52786 9.34102 4.52786H12.3002C13.0267 4.52786 13.3288 5.45758 12.741 5.88463L10.347 7.62398C10.0841 7.81497 9.97415 8.15349 10.0746 8.46251L10.989 11.2768C11.2135 11.9678 10.4226 12.5424 9.83486 12.1154L7.44084 10.376C7.17797 10.185 6.82203 10.185 6.55916 10.376L4.16514 12.1154C3.57735 12.5424 2.7865 11.9678 3.01101 11.2768L3.92544 8.46251C4.02585 8.15349 3.91586 7.81497 3.65299 7.62398L1.25897 5.88463C0.671185 5.45757 0.973268 4.52786 1.69981 4.52786H4.65898C4.9839 4.52786 5.27187 4.31864 5.37227 4.00963L6.28671 1.19529Z"
				fill={props.fill || '#003E74'}
			/>
		</svg>
	),
	filters: (props: IconProps) => (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H28C32.1421 0.5 35.5 3.85786 35.5 8V28C35.5 32.1421 32.1421 35.5 28 35.5H8C3.85786 35.5 0.5 32.1421 0.5 28V8Z"
				stroke="#E2E8F0"
			/>
			<path
				d="M26.5 13H24"
				stroke="#FB6000"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M26.5 23H21.5"
				stroke="#FB6000"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 23H9.5"
				stroke="#FB6000"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.5 13H9.5"
				stroke="#FB6000"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19 10H23C23.5523 10 24 10.4477 24 11V15C24 15.5523 23.5523 16 23 16H19C18.4477 16 18 15.5523 18 15V11C18 10.4477 18.4477 10 19 10Z"
				stroke="#FB6000"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M13 20H17C17.5523 20 18 20.4477 18 21V25C18 25.5523 17.5523 26 17 26H13C12.4477 26 12 25.5523 12 25V21C12 20.4477 12.4477 20 13 20Z"
				stroke="#FB6000"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	filtersSmall: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13.668 4.66602H12.0013"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.668 11.334H10.3346"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4 11.334H2.33333"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.66797 4.66602H2.33464"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.66667 2.66602H11.3333C11.7015 2.66602 12 2.9645 12 3.33268V5.99935C12 6.36754 11.7015 6.66602 11.3333 6.66602H8.66667C8.29847 6.66602 8 6.36754 8 5.99935V3.33268C8 2.9645 8.29847 2.66602 8.66667 2.66602Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M4.66667 9.33398H7.33333C7.70153 9.33398 8 9.63245 8 10.0007V12.6673C8 13.0355 7.70153 13.334 7.33333 13.334H4.66667C4.29847 13.334 4 13.0355 4 12.6673V10.0007C4 9.63245 4.29847 9.33398 4.66667 9.33398Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	logoSmaller: (props: IconProps) => (
		<svg
			width="21"
			height="30"
			viewBox="0 0 21 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 10.0291L0 25.3938C0 26.2493 0.726348 26.9428 1.62234 26.9428L18.9273 26.9428C19.8233 26.9428 20.5497 26.2493 20.5497 25.3938L20.5497 10.0291C20.5497 9.61826 20.3788 9.22427 20.0745 8.93377L11.422 0.672441C10.7885 0.0675195 9.76124 0.0675195 9.12768 0.672441L0.475174 8.93377C0.170926 9.22427 0 9.61826 0 10.0291ZM10.2748 5.2568C10.7975 5.2568 11.2212 4.85225 11.2212 4.35322C11.2212 3.85418 10.7975 3.44963 10.2748 3.44963C9.75218 3.44963 9.32848 3.85418 9.32848 4.35322C9.32848 4.85225 9.75218 5.2568 10.2748 5.2568Z"
				fill="#FB6000"
			/>
			<path
				d="M4.09073 12.3897C3.92769 12.5351 3.83594 12.7334 3.83594 12.9402L3.83594 22.4238C3.83594 22.8514 4.22021 23.1981 4.69424 23.1981H7.91286C8.38689 23.1981 8.77116 22.8514 8.77116 22.4238L8.77116 18.8108C8.77116 18.3832 9.15544 18.0366 9.62947 18.0366H10.2732H10.9169C11.3909 18.0366 11.7752 18.3832 11.7752 18.8108L11.7752 22.4238C11.7752 22.8514 12.1595 23.1981 12.6335 23.1981L15.8521 23.1981C16.3262 23.1981 16.7104 22.8514 16.7104 22.4238V12.9402C16.7104 12.7334 16.6187 12.5351 16.4557 12.3897L10.8767 7.41317C10.5423 7.11488 10.0041 7.11488 9.66968 7.41317L4.09073 12.3897Z"
				fill="white"
			/>
			<path
				d="M0 29.1377C0 28.7812 0.302645 28.4922 0.675977 28.4922L19.8737 28.4922C20.247 28.4922 20.5497 28.7812 20.5497 29.1377C20.5497 29.4942 20.247 29.7832 19.8737 29.7832L0.675977 29.7832C0.302645 29.7832 0 29.4942 0 29.1377Z"
				fill="#FB6000"
			/>
		</svg>
	),
	trashCan: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13 3.66602L12.5869 10.3494C12.4813 12.0569 12.4285 12.9107 12.0005 13.5246C11.7889 13.8281 11.5165 14.0842 11.2005 14.2767C10.5614 14.666 9.706 14.666 7.99513 14.666C6.28208 14.666 5.42553 14.666 4.78603 14.2759C4.46987 14.0831 4.19733 13.8265 3.98579 13.5225C3.55792 12.9077 3.5063 12.0527 3.40307 10.3428L3 3.66602"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M2 3.66732H14M10.7038 3.66732L10.2487 2.72847C9.9464 2.10482 9.7952 1.793 9.53447 1.59852C9.47667 1.55538 9.4154 1.51701 9.35133 1.48378C9.0626 1.33398 8.71607 1.33398 8.023 1.33398C7.31253 1.33398 6.95733 1.33398 6.66379 1.49006C6.59873 1.52466 6.53665 1.56458 6.47819 1.60943C6.21443 1.81178 6.06709 2.13502 5.77241 2.78149L5.36861 3.66732"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M6.33301 11V7"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M9.66699 11V7"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	iconAlert: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M12 8.5V12.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 16H12.009"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconAlertSmall: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.00732 5.33219V7.99886M8.00732 10.6655H8.00066M14.6668 7.9987C14.6668 11.6806 11.6821 14.6654 8.00016 14.6654C4.31826 14.6654 1.3335 11.6806 1.3335 7.9987C1.3335 4.3168 4.31826 1.33203 8.00016 1.33203C11.6821 1.33203 14.6668 4.3168 14.6668 7.9987Z"
				stroke="#64748B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconArrow: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.5 6.5L6 18"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 6H18V16"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	plane: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.8667 3.7804C16.7931 3.03188 17.8307 2.98644 18.9644 3.00233C19.5508 3.01055 19.844 3.01467 20.0792 3.10588C20.4524 3.2506 20.7494 3.54764 20.8941 3.92081C20.9853 4.15601 20.9894 4.4492 20.9977 5.03557C21.0136 6.16926 20.9681 7.20686 20.2196 8.13326C19.5893 8.91337 18.5059 9.32101 17.9846 10.1821C17.5866 10.8395 17.772 11.5203 17.943 12.2209L19.2228 17.4662C19.4779 18.5115 19.2838 19.1815 18.5529 19.9124C18.164 20.3013 17.8405 20.2816 17.5251 19.779L13.6627 13.6249L11.8181 15.0911C11.1493 15.6228 10.8149 15.8886 10.6392 16.2627C10.2276 17.1388 10.4889 18.4547 10.5022 19.4046C10.5096 19.9296 10.0559 20.9644 9.41391 20.9993C9.01756 21.0209 8.88283 20.5468 8.75481 20.2558L7.52234 17.4544C7.2276 16.7845 7.21552 16.7724 6.54556 16.4777L3.74415 15.2452C3.45318 15.1172 2.97914 14.9824 3.00071 14.5861C3.03565 13.9441 4.07036 13.4904 4.59536 13.4978C5.54532 13.5111 6.86122 13.7724 7.73734 13.3608C8.11142 13.1851 8.37724 12.8507 8.90888 12.1819L10.3751 10.3373L4.22103 6.47489C3.71845 6.15946 3.69872 5.83597 4.08755 5.44715C4.8185 4.7162 5.48851 4.52214 6.53377 4.77718L11.7791 6.05703C12.4797 6.22798 13.1605 6.41343 13.8179 6.0154C14.679 5.49411 15.0866 4.41074 15.8667 3.7804Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	bed: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M22 17H2"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 21V14C22 12.8954 21.1046 12 20 12H4C2.89543 12 2 12.8954 2 14V21"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 12V10.309C16 10.1196 15.8935 9.94708 15.7199 9.87128C15.1014 9.60118 13.5507 9 12 9C10.4493 9 8.89856 9.60118 8.28011 9.87128C8.10655 9.94708 8 10.1196 8 10.309V12"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 12V6.46798C20 6.17143 19.8696 5.88847 19.6357 5.70611C17.4413 3.99491 14.8181 3 12 3C9.18187 3 6.5587 3.99491 4.36426 5.70611C4.1304 5.88846 4 6.17143 4 6.46798V12"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	town: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13 2L2 7"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 3V22H7C5.11438 22 4.17157 22 3.58579 21.4142C3 20.8284 3 19.8856 3 18V7"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 7L22 12"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 21.9997H17C18.8856 21.9997 19.8284 21.9997 20.4142 21.4139C21 20.8281 21 19.8853 21 17.9997V11.5"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 10V7"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 11H8M7 15H8"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 14H17"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.5 22V18"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconArrowSmall: (props: IconProps) => (
		<svg
			width="17"
			height="16"
			viewBox="0 0 17 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.1667 4.33203L4.5 11.9987"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.8335 4H12.5002V10.6667"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconArrowLeft: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M2.66797 8H13.3346"
				stroke={props.stroke || '#64748B'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.00128 11.3333C6.00128 11.3333 2.66798 8.87836 2.66797 7.99996C2.66796 7.12156 6.0013 4.66663 6.0013 4.66663"
				stroke={props.stroke || '#64748B'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconTopRating: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M2 6L9.33333 6.00008"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 10H6.66667"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 2H12.6667"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.3332 14V6M12.3332 14C11.8664 14 10.9942 12.6705 10.6665 12.3333M12.3332 14C12.8 14 13.6722 12.6705 13.9998 12.3333"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconPriceUp: (props: IconProps) => (
		<svg
			width="16"
			height="17"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.3337 2V10M12.3337 2C11.8669 2 10.9947 3.32953 10.667 3.66667M12.3337 2C12.8005 2 13.6727 3.32953 14.0003 3.66667"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.75 7.08512C7.75 5.74872 6.51878 4.66536 5 4.66536M5 4.66536C3.48121 4.66536 2.25 5.74872 2.25 7.08512C2.25 8.4215 3 9.15916 5 9.15916C7 9.15916 8 9.85056 8 11.579C8 13.3074 6.65685 13.9987 5 13.9987M5 4.66536V3.33203M5 13.9987C3.34315 13.9987 2 12.9154 2 11.579M5 13.9987V15.332"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	iconPriceDown: (props: IconProps) => (
		<svg
			width="16"
			height="17"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.3337 15V7M12.3337 15C11.8669 15 10.9947 13.6705 10.667 13.3333M12.3337 15C12.8005 15 13.6727 13.6705 14.0003 13.3333"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.75 5.42106C7.75 4.08466 6.51878 3.0013 5 3.0013M5 3.0013C3.48121 3.0013 2.25 4.08466 2.25 5.42106C2.25 6.75744 3 7.4951 5 7.4951C7 7.4951 8 8.1865 8 9.9149C8 11.6433 6.65685 12.3346 5 12.3346M5 3.0013V1.66797M5 12.3346C3.34315 12.3346 2 11.2513 2 9.9149M5 12.3346V13.668"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	iconShield: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.99935 7.66666L7.33268 9L10.3327 6M13.3327 8C13.3327 11.2723 9.76338 13.6523 8.46468 14.4099C8.31708 14.496 8.24328 14.5391 8.13914 14.5614C8.05831 14.5787 7.94039 14.5787 7.85956 14.5614C7.75541 14.5391 7.68162 14.496 7.53402 14.4099C6.23532 13.6523 2.66602 11.2723 2.66602 8V4.81173C2.66602 4.27872 2.66602 4.01222 2.75319 3.78313C2.8302 3.58076 2.95534 3.40018 3.11779 3.25702C3.30168 3.09495 3.55121 3.00138 4.05029 2.81423L7.62482 1.47378C7.76341 1.4218 7.83271 1.39582 7.904 1.38552C7.96724 1.37638 8.03146 1.37638 8.09469 1.38552C8.16598 1.39582 8.23528 1.4218 8.37388 1.47378L11.9484 2.81423C12.4475 3.00138 12.697 3.09495 12.8809 3.25702C13.0434 3.40018 13.1685 3.58076 13.2455 3.78313C13.3327 4.01222 13.3327 4.27872 13.3327 4.81173V8Z"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconNoMoney: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14.6673 9.00004V5.46671C14.6673 4.71997 14.6673 4.3466 14.522 4.06139C14.3942 3.8105 14.1902 3.60653 13.9393 3.4787C13.6541 3.33337 13.2807 3.33337 12.534 3.33337L3.46732 3.33337C2.72058 3.33337 2.34721 3.33337 2.062 3.4787C1.81111 3.60653 1.60714 3.8105 1.47931 4.06139C1.33398 4.3466 1.33398 4.71997 1.33398 5.46671L1.33398 10.5334C1.33398 11.2801 1.33398 11.6535 1.47931 11.9387C1.60714 12.1896 1.81111 12.3935 2.062 12.5214C2.34721 12.6667 2.72058 12.6667 3.46732 12.6667H9.66732M4.00065 7.00004V9.00004M12.0007 7.00004V9.00004M11.4793 11L13.0007 12.5214M13.0007 12.5214L14.522 14.0427M13.0007 12.5214L14.522 11M13.0007 12.5214L11.4793 14.0427M9.66732 8.00004C9.66732 8.92051 8.92113 9.66671 8.00065 9.66671C7.08018 9.66671 6.33398 8.92051 6.33398 8.00004C6.33398 7.07957 7.08018 6.33337 8.00065 6.33337C8.92113 6.33337 9.66732 7.07957 9.66732 8.00004Z"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconCheckin: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9 17.625C9.0736 19.4769 10.6169 21.0494 12.6844 20.9988C13.1654 20.9871 13.7599 20.8194 14.9489 20.484C17.8104 19.6769 20.2944 18.3204 20.8904 15.2816C21 14.723 21 14.0944 21 12.8373V11.1627C21 9.90564 21 9.27707 20.8904 8.71848C20.2944 5.67966 17.8104 4.32317 14.9489 3.51603C13.7599 3.18065 13.1654 3.01296 12.6844 3.00119C10.6169 2.95061 9.0736 4.52308 9 6.37502"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M14 12H3M14 12C14 11.2998 12.0057 9.99153 11.5 9.5M14 12C14 12.7002 12.0057 14.0085 11.5 14.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconCheckout: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15 17.625C14.9264 19.4769 13.3831 21.0494 11.3156 20.9988C10.8346 20.9871 10.2401 20.8194 9.05112 20.484C6.18961 19.6769 3.70555 18.3204 3.10956 15.2816C3 14.723 3 14.0944 3 12.8373V11.1627C3 9.90564 3 9.27707 3.10956 8.71848C3.70555 5.67966 6.18961 4.32317 9.05112 3.51603C10.2401 3.18065 10.8346 3.01296 11.3156 3.00119C13.3831 2.95061 14.9264 4.52308 15 6.37502"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M21 12H10M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconImagePlaceholder: (props: IconProps) => (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M3.33398 16.0007C3.33398 10.0295 3.33398 7.04397 5.18897 5.18897C7.04397 3.33398 10.0295 3.33398 16.0007 3.33398C21.9717 3.33398 24.9573 3.33398 26.8124 5.18897C28.6673 7.04397 28.6673 10.0295 28.6673 16.0007C28.6673 21.9717 28.6673 24.9573 26.8124 26.8124C24.9573 28.6673 21.9717 28.6673 16.0007 28.6673C10.0295 28.6673 7.04397 28.6673 5.18897 26.8124C3.33398 24.9573 3.33398 21.9717 3.33398 16.0007Z"
				stroke="white"
				strokeWidth="1.5"
			/>
			<path
				d="M22 12C23.1046 12 24 11.1046 24 10C24 8.89543 23.1046 8 22 8C20.8954 8 20 8.89543 20 10C20 11.1046 20.8954 12 22 12Z"
				stroke="white"
				strokeWidth="1.5"
			/>
			<path
				d="M21.3333 29.3327C20.5073 26.3659 18.5793 23.7088 15.8353 21.7783C12.8768 19.6965 9.16217 18.5948 5.35425 18.6696C4.90211 18.6685 4.45035 18.6829 4 18.7128"
				stroke="white"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M17.334 24.0006C19.6027 22.2317 22.0467 21.3243 24.5156 21.3341C25.9156 21.3326 27.3089 21.6294 28.6673 22.2162"
				stroke="white"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),

	wifi: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			{...props}
		>
			<path
				d="M12 18.5H12.0118"
				stroke="#1D1D1D"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M8.25 15.5C10.25 13.5 13.75 13.5 15.75 15.5"
				stroke="#1D1D1D"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M18.5 12.5C14.7324 9.16667 9.5 9.16667 5.5 12.5"
				stroke="#1D1D1D"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M2 9.5C8.31579 4.16669 15.6842 4.16668 22 9.49989"
				stroke="#1D1D1D"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	pool: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			{...props}
		>
			<path
				d="M22 21H21C19.5486 21 18.278 20.1411 18 19C17.722 20.1411 16.4514 21 15 21C13.5486 21 12.278 20.1411 12 19C11.722 20.1411 10.4514 21 9 21C7.54863 21 6.27796 20.1411 6 19C5.72204 20.1411 4.45137 21 3 21H2"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19 3L18.7351 3.0883C17.4151 3.52832 16.755 3.74832 16.3775 4.2721C16 4.79587 16 5.49159 16 6.88304V17"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 3L10.7351 3.0883C9.41505 3.52832 8.75503 3.74832 8.37752 4.2721C8 4.79587 8 5.49159 8 6.88304V17"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 7H16M8 11H16M8 15H16"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	parking: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke="#141B34"
				strokeWidth="1.5"
			/>
			<path
				d="M9 13V8.4C9 8.02774 9 7.84162 9.04894 7.69098C9.14786 7.38655 9.38655 7.14786 9.69098 7.04894C9.84162 7 10.0277 7 10.4 7H13C14.6569 7 16 8.34315 16 10C16 11.6569 14.6569 13 13 13H9ZM9 13V18"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	twentyFourHours: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.04798 8.60657L2.53784 8.45376C4.33712 3.70477 9.503 0.999917 14.5396 2.34474C19.904 3.77711 23.0904 9.26107 21.6565 14.5935C20.2227 19.926 14.7116 23.0876 9.3472 21.6553C5.36419 20.5917 2.58192 17.2946 2 13.4844"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 10.8C7 9.80589 7.86342 9 8.92857 9C9.99372 9 10.8571 9.80589 10.8571 10.8C10.8571 12.0472 9.00546 13.1503 7.86805 13.7103C7.35155 13.9646 7 14.455 7 15H10.8571M17 9V12.3M17 12.3V15M17 12.3H13.4231C13.2683 12.3 13.1429 12.1829 13.1429 12.0384C13.1429 12.013 13.1468 11.9876 13.1547 11.9632L14.1071 9"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	family: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.5 11C15.5 9.067 13.933 7.5 12 7.5C10.067 7.5 8.5 9.067 8.5 11C8.5 12.933 10.067 14.5 12 14.5C13.933 14.5 15.5 12.933 15.5 11Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.483 11.3499C15.805 11.4475 16.1465 11.5 16.5003 11.5C18.4333 11.5 20.0003 9.933 20.0003 8C20.0003 6.067 18.4333 4.5 16.5003 4.5C14.6854 4.5 13.1931 5.8814 13.0176 7.65013"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.9827 7.65013C10.8072 5.8814 9.31492 4.5 7.5 4.5C5.567 4.5 4 6.067 4 8C4 9.933 5.567 11.5 7.5 11.5C7.85381 11.5 8.19535 11.4475 8.51727 11.3499"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 16.5C22 13.7386 19.5376 11.5 16.5 11.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.5 19.5C17.5 16.7386 15.0376 14.5 12 14.5C8.96243 14.5 6.5 16.7386 6.5 19.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.5 11.5C4.46243 11.5 2 13.7386 2 16.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	beach: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M2 15.7501C2 15.7501 3.79534 15 7 15C12 15 16 18 22 18"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 21H22"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.594 3.22761C9.74838 4.04368 7.89871 6.85224 8.0043 9.87504C8.02623 10.5029 8.03719 10.8168 8.30546 10.9556C8.57373 11.0944 8.85218 10.8977 9.40908 10.5041L10.6506 9.6268C10.8371 9.49503 11.0585 9.43155 11.2815 9.44587L14.1977 9.63321L16.6357 7.91042C16.8222 7.77865 17.0435 7.71517 17.2666 7.7295L18.7879 7.82723C19.4407 7.86916 19.7671 7.89013 19.9291 7.63883C20.0912 7.38753 19.9594 7.11583 19.6959 6.57242C18.3856 3.86989 15.4553 2.40707 12.594 3.22761Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.5 9.5L16.5 17M12.2857 3L12 2"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	cocktail: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.20538 15.3582L4.51713 11.0812C2.62475 8.88671 1.67856 7.78948 2.09833 6.89474C2.5181 6 3.97907 6 6.90099 6H11.099C14.0209 6 15.4819 6 15.9017 6.89474C16.3214 7.78948 15.3753 8.88671 13.4829 11.0812L9.79462 15.3582C9.42563 15.7861 9.24114 16 9 16C8.75886 16 8.57437 15.7861 8.20538 15.3582Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M8.5 6L8.09898 3.59389C8.03809 3.22852 7.78022 2.92674 7.42882 2.80961L5 2"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M9 16V22M6 22H12"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M15.8601 8.83333C16.5043 9.54937 17.4403 10 18.4822 10C20.425 10 22 8.433 22 6.5C22 4.567 20.425 3 18.4822 3C16.71 3 15.2438 4.30385 15 6"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	pets: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M21.4565 7.97344C21.2899 7.90795 21.1124 7.87455 20.9334 7.875H20.9146C19.9691 7.88906 18.9088 8.77453 18.3524 10.1138C17.6854 11.7159 17.9924 13.3552 19.0434 13.7766C19.2098 13.8421 19.3871 13.8755 19.566 13.875C20.5162 13.875 21.591 12.9844 22.1521 11.6363C22.8144 10.0341 22.5027 8.39484 21.4565 7.97344ZM15.3562 14.2256C14.053 12.0633 13.4905 11.25 11.9999 11.25C10.5093 11.25 9.9421 12.0684 8.63898 14.2256C7.52335 16.0706 5.26866 16.2244 4.70616 17.7914C4.59204 18.0784 4.53473 18.3849 4.53741 18.6937C4.53741 19.9683 5.51241 21 6.71241 21C8.20304 21 10.2327 19.8098 12.0046 19.8098C13.7765 19.8098 15.7968 21 17.2874 21C18.4874 21 19.4577 19.9687 19.4577 18.6937C19.4588 18.3846 19.3999 18.0781 19.2843 17.7914C18.7218 16.2187 16.4718 16.0706 15.3562 14.2256ZM9.02382 9.1875C9.08659 9.18756 9.14927 9.18286 9.21132 9.17344C10.2993 9.01547 10.9785 7.50797 10.7319 5.80547C10.4999 4.20047 9.52585 3 8.50726 3C8.44449 2.99994 8.38181 3.00465 8.31976 3.01406C7.23179 3.17203 6.55257 4.67953 6.79913 6.38203C7.03116 7.98234 8.00523 9.1875 9.02382 9.1875ZM17.1993 6.38203C17.4459 4.67953 16.7666 3.17203 15.6787 3.01406C15.6166 3.00465 15.5539 2.99994 15.4912 3C14.4726 3 13.5004 4.20047 13.2679 5.80547C13.0213 7.50797 13.7005 9.01547 14.7885 9.17344C14.8506 9.18286 14.9132 9.18756 14.976 9.1875C15.9946 9.1875 16.9687 7.98234 17.1993 6.38203ZM4.95788 13.7766C6.00741 13.3547 6.31398 11.7141 5.64788 10.1138C5.08726 8.76563 4.01335 7.875 3.0646 7.875C2.88573 7.8745 2.70838 7.9079 2.54195 7.97344C1.49241 8.39531 1.18585 10.0359 1.85195 11.6363C2.41257 12.9844 3.48648 13.875 4.43523 13.875C4.6141 13.8755 4.79145 13.8421 4.95788 13.7766Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</svg>
	),
	spa: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M4 14.0695C5.0145 14.0695 6.43122 13.7685 7.31944 14.4193L9.08188 15.7108C9.73667 16.1906 10.4458 16.0325 11.1765 15.9178C12.1389 15.7667 13 16.5875 13 17.6562C13 17.9482 10.9272 18.6905 10.6276 18.8316C10.0391 19.1088 9.36297 19.0406 8.83021 18.6502L6.84211 17.1934"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13 17L17.091 15.1096C17.8244 14.854 18.6331 15.0535 19.1797 15.625L19.8505 16.3262C20.0902 16.5768 20.0338 16.9976 19.7375 17.1697L11.8829 21.7315C11.4097 22.0063 10.8514 22.0734 10.3309 21.9179L4 20.0269"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.002 12C12.002 12 14.102 9.76142 14.102 7C14.102 4.23858 12.002 2 12.002 2C12.002 2 9.90195 4.23858 9.90195 7C9.90195 9.76142 12.002 12 12.002 12ZM12.002 12C12.002 12 15.069 11.9316 17.002 9.95918C18.935 7.98674 19.002 4.85714 19.002 4.85714C19.002 4.85714 17.7325 4.88544 16.3123 5.43087M12.002 12C12.002 12 8.93495 11.9316 7.00195 9.95918C5.06895 7.98674 5.00195 4.85714 5.00195 4.85714C5.00195 4.85714 6.2714 4.88544 7.69162 5.43087"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	airConditioner: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M2 5.94145C5.5 9.37313 10.5755 7.90241 11.7324 5.94145C11.9026 5.65301 12 5.31814 12 4.96096C12 3.87795 11.1046 3 10 3C8.89543 3 8 3.87795 8 4.96096"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M17 8.92814C17 7.31097 18.1193 6 19.5 6C20.8807 6 22 7.31097 22 8.92814C22 9.6452 21.7799 10.3021 21.4146 10.8111C19.3463 14.1915 9.2764 12.9164 4 11.8563"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M13.0854 19.8873C13.2913 20.5356 13.8469 21 14.5 21C15.3284 21 16 20.2528 16 19.331C16 19.0176 15.9224 18.7244 15.7873 18.4738C14.4999 15.9925 7.99996 14.3239 2 18.7746"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M19 15.5H21"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	houseKeeping: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M21 3L13 11.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.44573 11.0854C6.96539 12.0368 4.98269 11.8736 3 11.0885C3.50059 17.531 6.50414 20.0089 10.5089 21C10.5089 21 13.5261 18.8664 13.961 13.8074C14.0081 13.2595 14.0317 12.9856 13.9178 12.6769C13.8038 12.3682 13.5802 12.1468 13.1329 11.704C12.3973 10.9757 12.0295 10.6116 11.5929 10.5204C11.1564 10.4293 10.5862 10.648 9.44573 11.0854Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.5 16.4464C4.5 16.4464 7 16.9286 9.5 15"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.5 7.25C8.5 7.94036 7.94036 8.5 7.25 8.5C6.55964 8.5 6 7.94036 6 7.25C6 6.55964 6.55964 6 7.25 6C7.94036 6 8.5 6.55964 8.5 7.25Z"
				stroke="#1E293B"
				strokeWidth="1.5"
			/>
			<path
				d="M11 4V4.1"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	sofa: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6 17V20M18 17V20"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 9C20 7.13077 20 6.19615 19.5981 5.5C19.3348 5.04394 18.9561 4.66523 18.5 4.40192C17.8038 4 16.8692 4 15 4H9C7.13077 4 6.19615 4 5.5 4.40192C5.04394 4.66523 4.66523 5.04394 4.40192 5.5C4 6.19615 4 7.13077 4 9"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 9C18.8954 9 18 9.89543 18 11V13C18 13.8273 17.8273 14 17 14H7C6.17267 14 6 13.8273 6 13V11C6 9.89543 5.10457 9 4 9C2.89543 9 2 9.89543 2 11C2 11.7403 2.4022 12.3866 3 12.7324V13C3 14.8856 3 15.8284 3.58579 16.4142C4.17157 17 5.11438 17 7 17H17C18.8856 17 19.8284 17 20.4142 16.4142C21 15.8284 21 14.8856 21 13V12.7324C21.5978 12.3866 22 11.7403 22 11C22 9.89543 21.1046 9 20 9Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	kitchen: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6 5H10"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M18 5.00895V5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 8H21"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M2 22H22"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M3 22V5C3 2.518 3.518 2 6 2H18C20.482 2 21 2.518 21 5V22"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 17V13C6 12.0572 6 11.5858 6.29289 11.2929C6.58579 11 7.05719 11 8 11H16C16.9428 11 17.4142 11 17.7071 11.2929C18 11.5858 18 12.0572 18 13V17C18 17.9428 18 18.4142 17.7071 18.7071C17.4142 19 16.9428 19 16 19H8C7.05719 19 6.58579 19 6.29289 18.7071C6 18.4142 6 17.9428 6 17Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	microwave: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M2 15V7C2 5.11438 2 4.17157 2.58579 3.58579C3.17157 3 4.11438 3 6 3H18C19.8856 3 20.8284 3 21.4142 3.58579C22 4.17157 22 5.11438 22 7V15C22 16.8856 22 17.8284 21.4142 18.4142C20.8284 19 19.8856 19 18 19H6C4.11438 19 3.17157 19 2.58579 18.4142C2 17.8284 2 16.8856 2 15Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M19 6.00895V6M19 9.00447V8.99553M19 12V11.9911"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5 14V8C5 7.05719 5 6.58579 5.29289 6.29289C5.58579 6 6.05719 6 7 6H14C14.9428 6 15.4142 6 15.7071 6.29289C16 6.58579 16 7.05719 16 8V14C16 14.9428 16 15.4142 15.7071 15.7071C15.4142 16 14.9428 16 14 16H7C6.05719 16 5.58579 16 5.29289 15.7071C5 15.4142 5 14.9428 5 14Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M5 19V21M19 19V21"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	iconAngle: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M11.6667 4.33337L4 12"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.33325 4H11.9999V10.6667"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconEdit: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_55973_5048)">
				<path
					d="M9.38312 2.59034C9.87992 2.05209 10.1283 1.78297 10.3923 1.62599C11.0291 1.24721 11.8134 1.23543 12.4609 1.59492C12.7293 1.74391 12.9853 2.00545 13.4973 2.52855C14.0094 3.05164 14.2655 3.31319 14.4113 3.58733C14.7632 4.24879 14.7517 5.0499 14.3809 5.70051C14.2272 5.97015 13.9637 6.22389 13.4369 6.73137L7.16772 12.7696C6.16924 13.7313 5.66999 14.2122 5.04603 14.4558C4.42207 14.6996 3.73612 14.6816 2.36423 14.6458L2.17757 14.6409C1.75993 14.63 1.5511 14.6245 1.42971 14.4867C1.30832 14.349 1.32489 14.1362 1.35804 13.7108L1.37604 13.4798C1.46933 12.2824 1.51597 11.6837 1.74979 11.1455C1.98361 10.6073 2.38695 10.1704 3.19361 9.29637L9.38312 2.59034Z"
					stroke="#64748B"
					strokeWidth="1.5"
					strokeLinejoin="round"
				/>
				<path
					d="M8.66602 2.66663L13.3327 7.33329"
					stroke="#64748B"
					strokeWidth="1.5"
					strokeLinejoin="round"
				/>
				<path
					d="M9.33398 14.6666H14.6673"
					stroke="#64748B"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_55973_5048">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	),
	socialFacebook: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_social_fb)">
				<path
					d="M12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24.0005 18.1354 24.0005 12C24 5.37264 18.6274 0 12 0Z"
					fill={props.fill || 'currentColor'}
				/>
			</g>
			<defs>
				<clipPath id="clip0_social_fb">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	),
	socialX: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18.3263 1.90381H21.6998L14.3297 10.3273L23 21.7898H16.2112L10.894 14.8378L4.80995 21.7898H1.43443L9.31743 12.7799L1 1.90381H7.96111L12.7674 8.25814L18.3263 1.90381ZM17.1423 19.7706H19.0116L6.94539 3.81694H4.93946L17.1423 19.7706Z"
				fill={props.fill || 'currentColor'}
			/>
		</svg>
	),
	socialLinkedin: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_social_linkedin)">
				<path
					d="M22.2234 0H1.77187C0.792187 0 0 0.773438 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773438 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43438C4.19531 7.43438 3.27188 6.51094 3.27188 5.37187C3.27188 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50625 6.47813 7.43438 5.33906 7.43438ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5563 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2938 12.9094 14.7891V20.4516H9.35625V8.99531H12.7687V10.5609H12.8156C13.2891 9.66094 14.4516 8.70938 16.1813 8.70938C19.7859 8.70938 20.4516 11.0813 20.4516 14.1656V20.4516V20.4516Z"
					fill={props.fill || 'currentColor'}
				/>
			</g>
			<defs>
				<clipPath id="clip0_social_linkedin">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	),
	linkChain: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6.66797 8.81917C6.76237 8.97377 6.87444 9.1201 7.0041 9.25504C7.8091 10.0928 9.0361 10.2238 9.97303 9.64797C10.1466 9.54124 10.3102 9.4103 10.4594 9.25504L12.619 7.00744C13.5732 6.0144 13.5732 4.40434 12.619 3.41129C11.6648 2.41824 10.1178 2.41824 9.16364 3.41129L8.68797 3.90636"
				stroke={props.stroke || 'currentColor'}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M7.31484 12.0933L6.83897 12.5885C5.88481 13.5816 4.33778 13.5816 3.3836 12.5885C2.42942 11.5955 2.42942 9.98546 3.3836 8.9924L5.54322 6.7448C6.49739 5.75174 8.04444 5.75173 8.99857 6.7448C9.12824 6.87966 9.24024 7.026 9.33464 7.18053"
				stroke={props.stroke || 'currentColor'}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	blogEmptyState: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9.99485 2.0214C7.49638 1.91562 5.56612 2.20344 5.56612 2.20344C4.34727 2.29059 2.01146 2.97391 2.01148 6.9646C2.0115 10.9214 1.98564 15.7994 2.01148 17.744C2.01148 18.9321 2.7471 21.7034 5.29326 21.8519C8.3881 22.0325 13.9627 22.0709 16.5204 21.8519C17.2051 21.8133 19.4846 21.2758 19.7731 18.7957C20.072 16.2264 20.0125 14.4408 20.0125 14.0158"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.9998 7.01562C21.9998 9.77705 19.7591 12.0157 16.995 12.0157C14.2309 12.0157 11.9902 9.77705 11.9902 7.01562C11.9902 4.2542 14.2309 2.01562 16.995 2.01562C19.7591 2.01562 21.9998 4.2542 21.9998 7.01562Z"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M6.98047 13.0156H10.9804"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M6.98047 17.0156H14.9804"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M21 11L23 13"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
}
